import { useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import DailyFacultyReports from "./components/dailyFacultyReports";
import MonthlyFacultyReports from "./components/monthlyFacultyReports";
import { IFacultyReports } from "../../../models/faculty/facultyReports";
import { getSnapShots } from "../../../action/masters/snapShotActionCreator";
import { pageBlockId } from "../../../constants/pageBlocks";
import YearlyFacultyReports from "./components/yearlyFacultyReports";
import { setSnapShots } from "../../../store/slices/master/snapShotSlice";

const FacualtyReports = (props: IFacultyReports) => {
  const { getSnapShots } = props;
  const dispatch = useDispatch();

  useEffect(() => {
    getSnapShots();
  }, []);

  useEffect(() => {
    return () => {
      dispatch(setSnapShots([]));
    };
  }, []);

  // const getPageBlockData = (pageblockId: number) => {
  //   return snapShots?.find((snapshot) => snapshot.id === pageblockId);
  // };

  return (
    <>
      <div className="report-wrap reports-mobile">
        <div className="row">
          <div className="col-lg-12">
            <DailyFacultyReports />
          </div>
          <div className="col-lg-12 mt-3">
            <MonthlyFacultyReports />
          </div>
          <div className="col-lg-12 mt-3">
            <YearlyFacultyReports />
          </div>
        </div>
      </div>
    </>
  );
};

const mapDispatchToProps = {
  getSnapShots: () => getSnapShots(),
};

export default connect(null, mapDispatchToProps)(FacualtyReports);
